'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { PerformanceLabTypeformSnippet } from 'components/performance-lab/PerformanceLabTypeformSnippet';
import { buildPerformanceLabTypeformTracking } from 'utils/buildTypeformTrackingParams';
import { UHPL_PARTNERS_TYPEFORM_ID } from './plPartnersConstants';
import styles from './PlPartnersTypeformModal.module.css';

export const PlPartnersTypeformModal = () => {
  const t = useTranslations('performance-lab');
  const trackingParams = useMemo(
    () => buildPerformanceLabTypeformTracking('pl_partners'),
    [],
  );

  return (
    <div className={styles.container}>
      <PerformanceLabTypeformSnippet
        typeformId={UHPL_PARTNERS_TYPEFORM_ID}
        frameTitle={t('partnersPage.typeformTitle')}
        className="typeform-container"
        trackingParams={trackingParams}
      />
    </div>
  );
};
